export default {
  TENCENT_COS: 'tencent-cos',
  ALIYUN_OSS: 'aliyun-oss',
}
